export default "/images/bd22a98f355f3af4163cc321308a9af9.png";